module.exports = __webpack_public_path__ + "img/ms_b3_img3.17285514.png";